// Centralised date formatting — DD/MM/YYYY across the app.
export const formatDate = (v) => {
  if (!v) return "—";
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const formatDateTime = (v) => {
  if (!v) return "—";
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(d)} ${hh}:${mi}`;
};

/** ISO date (YYYY-MM-DD) suitable for filenames / API params. */
export const isoDate = (v = new Date()) => {
  const d = v instanceof Date ? v : new Date(v);
  return d.toISOString().slice(0, 10);
};
